import React from 'react';

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = '' }: SkeletonProps) {
  return (
    <div className={`animate-pulse bg-neutral-200 rounded ${className}`} />
  );
}

export function TableRowSkeleton({ columns = 6 }: { columns?: number }) {
  return (
    <tr>
      {Array.from({ length: columns }).map((_, i) => (
        <td key={i} className="px-4 py-3 border-b border-neutral-200">
          <Skeleton className="h-4 w-full" />
        </td>
      ))}
    </tr>
  );
}

export function TableSkeleton({ rows = 5, columns = 6 }: { rows?: number; columns?: number }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <TableRowSkeleton key={i} columns={columns} />
      ))}
    </>
  );
}

export function CardSkeleton() {
  return (
    <div className="bg-white border border-neutral-200 rounded-lg shadow-sm p-6">
      <Skeleton className="h-6 w-32 mb-4" />
      <div className="space-y-3">
        <Skeleton className="h-4 w-full" />
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
      </div>
    </div>
  );
}

export function KPICardSkeleton() {
  return (
    <div className="bg-white border border-neutral-200 rounded-lg shadow-sm p-4 text-center">
      <Skeleton className="h-8 w-24 mx-auto mb-2" />
      <Skeleton className="h-4 w-32 mx-auto" />
    </div>
  );
}

export function ChartSkeleton() {
  return (
    <div className="bg-white border border-neutral-200 rounded-lg shadow-sm">
      <div className="px-6 py-4 border-b border-neutral-200">
        <Skeleton className="h-5 w-40" />
      </div>
      <div className="p-6">
        <div className="flex justify-center items-center h-64">
          <div className="relative w-40 h-40">
            <Skeleton className="absolute inset-0 rounded-full" />
            <div className="absolute inset-8 bg-white rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

